import { ComponentProps } from "react";

import { useNavigation, useRoute } from "@react-navigation/native";

import { DeliveryFulfillmentsScreenProps } from "./types";
import { Header } from "../../../components";

type NavProps = DeliveryFulfillmentsScreenProps;
type Props = ComponentProps<typeof Header>;
export default function DeliveryFulfillmentsHeader(props: Props) {
  const { goBack } = useNavigation<NavProps["navigation"]>();
  const route = useRoute<NavProps["route"]>();

  return <Header title={route.name} onBackPress={goBack} {...props} />;
}
